import angular from 'angular';

export default angular.module('portainer.settings.general', []).name;
